export const Section = ({ id, num, title, kicker, children, breakBefore = true }) => (
  <section id={id} data-testid={`section-${id}`} className={`doc-section ${breakBefore ? "page-break" : ""}`}>
    <div className="flex items-baseline gap-4 mb-2">
      {num && <span className="font-display text-gold text-2xl">{num}</span>}
      <span className="kicker">{kicker}</span>
    </div>
    <h1 className="font-display text-4xl sm:text-5xl text-navy leading-[1.05] mb-6">{title}</h1>
    <div className="gold-rule mb-10" />
    {children}
  </section>
);

export const H2 = ({ children }) => (
  <h2 className="font-display text-2xl sm:text-[1.7rem] text-navy mt-12 mb-4 avoid-break">{children}</h2>
);

export const P = ({ children, className = "" }) => (
  <p className={`text-[15px] leading-[1.75] text-[var(--ink)] mb-4 ${className}`}>{children}</p>
);

export const Bullets = ({ items }) => (
  <ul className="space-y-2.5 mb-6">
    {items.map((it, i) => (
      <li key={i} className="flex gap-3 text-[15px] leading-[1.65]">
        <span className="mt-[9px] w-1.5 h-1.5 rotate-45 bg-[var(--gold)] shrink-0" />
        <span>{it}</span>
      </li>
    ))}
  </ul>
);

const rowKey = (r, i) => {
  const first = (r.cells || r)[0];
  return typeof first === "string" ? first : `row-${i}`;
};

export const Table = ({ head, rows, testId, foot }) => (
  <div className="avoid-break overflow-x-auto mb-6" data-testid={testId}>
    <table className="doc-table">
      <thead>
        <tr>{head.map((h, i) => <th key={`${h}-${i}`}>{h}</th>)}</tr>
      </thead>
      <tbody>
        {rows.map((r, i) => (
          <tr key={rowKey(r, i)} className={r.strong ? "row-strong" : ""}>
            {(r.cells || r).map((c, j) => <td key={`${head[j]}-${j}`}>{c}</td>)}
          </tr>
        ))}
      </tbody>
    </table>
    {foot && <p className="text-xs text-[var(--ink-soft)] mt-2 italic">{foot}</p>}
  </div>
);

export const Kpi = ({ value, label, testId }) => (
  <div data-testid={testId} className="kpi avoid-break">
    <div className="font-display text-3xl sm:text-4xl text-navy">{value}</div>
    <div className="text-xs uppercase tracking-[0.14em] text-[var(--ink-soft)] mt-2">{label}</div>
  </div>
);

export const Callout = ({ title, children }) => (
  <div className="callout avoid-break">
    {title && <div className="kicker mb-2">{title}</div>}
    <div className="text-[15px] leading-[1.7]">{children}</div>
  </div>
);

export const Figure = ({ caption, children }) => (
  <figure className="figure avoid-break">
    {children}
    {caption && <figcaption className="text-xs text-[var(--ink-soft)] mt-3 italic">{caption}</figcaption>}
  </figure>
);
